// Trailing-edge map reload coordinator. Scheduling a replacement aborts any
// active request immediately, then waits for the viewport to settle before
// starting the next one. `runNow` is used for the initial map load.
export function createAbortableDebounce(callback, delayMs = 300) {
  let timer = null
  let activeController = null

  function abortActive() {
    activeController?.abort()
    activeController = null
  }

  function runNow() {
    clearTimeout(timer)
    timer = null
    abortActive()
    activeController = typeof AbortController === "undefined" ? null : new AbortController()
    return callback(activeController?.signal)
  }

  return {
    runNow,
    schedule() {
      clearTimeout(timer)
      abortActive()
      timer = setTimeout(runNow, delayMs)
    },
    stop() {
      clearTimeout(timer)
      timer = null
      abortActive()
    }
  }
}
